import { ColorModeScript,ChakraProvider,theme } from '@chakra-ui/react';
import React, { StrictMode } from 'react';
import {ColorModeSwitcher} from './ColorModeSwitcher'
import * as ReactDOM from 'react-dom/client';
import App from './App';
const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <StrictMode>
    <ChakraProvider theme={theme}>
    <ColorModeScript />
    <App />
    <ColorModeSwitcher/>
    </ChakraProvider>
  </StrictMode>
);
export const server = 'https://api.coingecko.com/api/v3';

